import { Controller } from "@hotwired/stimulus"

// A <select> (or any input) that submits its form as soon as it changes —
// the Team members role dropdown, etc.
export default class extends Controller {
  submit() {
    this.element.form.requestSubmit()
  }
}
